import React from "react";
import Page_not_found from "../../assets/img/Error/Page_not_found.png";
import { Link } from "react-router-dom";

const Error404 = () => {
  return (
    <div className="container  ">
      <div className="col-lg-8 mx-auto d-flex align-items-center justify-content-center flex-column">
        <img src={Page_not_found} alt="Page_not_found" />
        <Link to="/" className="btn btn-primary btn-sm ">بازگشت به صفحه اصلی</Link>
      </div>
    </div>
  );
};

export default Error404;
